import { Smartphone, Tablet, Monitor } from "lucide-react";

const DEVICES = [
  { id: "mobile", label: "Mobile", icon: Smartphone, img: "/screenshots/participant_mobile.png", frame: "w-[150px] sm:w-[170px] rounded-[1.6rem] border-[5px]" },
  { id: "tablet", label: "Tablet", icon: Tablet, img: "/screenshots/participant_tablet.png", frame: "w-[190px] sm:w-[220px] rounded-[1.2rem] border-[6px]" },
  { id: "desktop", label: "Laptop", icon: Monitor, img: "/screenshots/participant_desktop.png", frame: "w-[260px] sm:w-[310px] rounded-xl border-[6px]" },
];

export function ParticipantShowcase() {
  return (
    <section className="px-6 py-20 bg-[#0B0F19] text-white relative overflow-hidden" data-testid="section-participant-showcase">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full bg-[#8B5CF6]/15 blur-[110px]" />
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#22D3EE] bg-white/5 border border-white/10 px-3 py-1.5 rounded-full mb-5">
            Join from any device
          </span>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mb-3">One code, every screen</h2>
          <p className="text-white/60 max-w-xl mx-auto">
            Participants jump in from a phone, tablet, or laptop browser — same glowing live stage, your brand front and center, no app to install.
          </p>
        </div>

        <div className="flex flex-wrap items-end justify-center gap-6 sm:gap-10">
          {DEVICES.map((d) => (
            <div key={d.id} className="flex flex-col items-center gap-3" data-testid={`participant-device-${d.id}`}>
              <div className={`${d.frame} border-[#1c1f2b] bg-[#1c1f2b] shadow-2xl shadow-black/50 overflow-hidden relative`}>
                <img src={d.img} alt={`VybeMeter participant screen on ${d.label.toLowerCase()}`} className="w-full block" />
              </div>
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-white/50">
                <d.icon className="w-3.5 h-3.5" /> {d.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
